import { createContext } from 'react'
import { endOfYear, startOfYear } from 'date-fns'

import { MAX_YEAR, MIN_YEAR, YEAR_FIRST_MONTH } from '../constants/date'

export const DateLimits = createContext({
  maxDate: endOfYear(new Date(MAX_YEAR, YEAR_FIRST_MONTH)),
  minDate: startOfYear(new Date(MIN_YEAR, YEAR_FIRST_MONTH)),
})
